/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ round: NonNullable<unknown> }} Sanction_Sa_Applies_ToInputs */



/**
* | output |
* | --- |
* | "Applies to the player's current/most-recent game: round {round}" |
*
* @param {Sanction_Sa_Applies_ToInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sa_applies_to = /** @type {((inputs: Sanction_Sa_Applies_ToInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sa_Applies_ToInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`S'applique à la partie en cours/la plus récente du joueur : Ronde ${i?.round}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se aplica a la partida actual/más reciente del jugador: Ronda ${i?.round}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Aplica-se à partida atual/mais recente do jogador: Rodada ${i?.round}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Si applica alla partita corrente/più recente del giocatore: Round ${i?.round}`)
	return /** @type {LocalizedString} */ (`Applies to the player's current/most-recent game: round ${i?.round}`)
});